import { chunk } from 'lodash';

import { getFormValuesObject } from './getFormValuesObject';
import { getRowChip, getRowFieldQualifierValue } from './getRow';
import { parseMaskedFieldQualifierValue } from './parseMaskedFieldQualifierValue';
import { BOOLEAN_CHIP, BOOLEAN_OPERATOR_REGEX, FormValues } from '../constants';

const getFormValuesWithInvalidQuery = (query: string): FormValues => {
  const formValues = getFormValuesObject();

  formValues[0].value = query;
  formValues[0].isInvalid = true;

  return formValues;
};

export const createBooleanChipQuery = chip => ` ${chip.toUpperCase()} `;
export const andBooleanChip = createBooleanChipQuery(BOOLEAN_CHIP.and);

export const parseMaskedAdvancedSearchQuery = (query: string): FormValues => {
  const regex = new RegExp(`${BOOLEAN_OPERATOR_REGEX}(?=\\w+ \\w+ ".*")`, 'g');

  const [firstRow, ...rowsWithChips] = query.split(regex);
  const rowValues = [
    [andBooleanChip, firstRow],
    ...chunk(rowsWithChips, 2),
  ].map(row => [getRowChip(row), getRowFieldQualifierValue(row)]);
  let isQueryInvalid = false;

  const formValues = rowValues.reduce((values: FormValues, row, index) => {
    const fieldQualifierValue = getRowFieldQualifierValue(row);

    try {
      values[index] = {
        ...parseMaskedFieldQualifierValue(fieldQualifierValue),
        ...(index > 0 && {
          booleanChip: getRowChip(row) as BOOLEAN_CHIP,
        }),
      };
    } catch (error) {
      isQueryInvalid = true;
    }

    return values;
  }, getFormValuesObject());

  return isQueryInvalid ? getFormValuesWithInvalidQuery(query) : formValues;
};
